module.exports = __webpack_public_path__ + "img/DOGE.ae64499c.png";